import { socket } from 'lib_ui-services';
export default {
    verb: 'doingCli',
    namespace: 'application',
    relation: 'socket',
    description: 'turn sockets on or off',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function logic({ data }) {
    if (data == null) return;
    if (data.online) {
        socket.setOnline();
    } else {
        socket.setOffline();
    }
}
